import type { FinanceOverview, FinanceReceivables } from '@oficina/shared';
import { api } from '@/lib/api';

export const financeService = {
  /** `period` AAAA-MM (mês) ou AAAA (ano inteiro). */
  overview: (period?: string) =>
    api.get<FinanceOverview>('/finance/overview', period && /^\d{4}$/.test(period) ? { year: period } : { month: period }),
  receivables: () => api.get<FinanceReceivables>('/finance/receivables'),
};
